// extracted by mini-css-extract-plugin
export default {"container":"container-AdWRx","header":"header-kFgwU","backBtn":"backBtn-bdW8e","content":"content-mkchk","stepper":"stepper-DcQof","btnBlock":"btnBlock-BRCTq"};